// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Poz+U","content":"styles_content__yaIZt","price":"styles_price__W06jz"};